import React from "react";
import Page from "../../Components/Page";
import styles from "./styles.module.scss";

const Outage = () => {
  return (
    <Page className={styles.page}>
      <div className={styles.content}>
        <h1>Outage Detected</h1>
        <p>
          Our service is currently experiencing an outage. Please try again in a
          few minutes.
        </p>
      </div>
    </Page>
  );
};

export default Outage;
